import { differenceInCalendarDays } from 'date-fns'
import { isUndefinedOrNull } from 'util/checks'

import { TerritorioMapaBuscaFormModel } from './mapa-busca/model-territorioMapaBusca'
import { TerritorioMapaCacheModel } from './model-territorioMapa'

export function shouldResetCacheByDate(now: number, lastUpdated: number | undefined | null) {
  return isUndefinedOrNull(lastUpdated) || differenceInCalendarDays(now, lastUpdated) > 0
}

export function resetCacheIfExpired(
  cacheValue: TerritorioMapaCacheModel,
  defaultFilter: TerritorioMapaBuscaFormModel,
  now: number
): TerritorioMapaCacheModel {
  if (shouldResetCacheByDate(now, cacheValue.lastUpdated)) {
    return {
      filter: defaultFilter,
      lastUpdated: now,
    }
  }

  return cacheValue
}
